import React, { useState, useEffect, useRef } from 'react'

// import Loader from '../../../loader';

import HomeSection01 from './HomeSection_01';

export default function Content(props) {

	const [, set_dados] = useState(null)
	const dados_config = useRef({})
	const dados_component = useRef({})
	const template = useRef({})
	const layout = useRef('')
	const content = useRef({})
	const pw = useRef({})

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            set_dados(dados_component.current = props.dados_component)
            set_dados(template.current = props.dados_config.info.template)
            set_dados(content.current = props.dados_config)
            set_dados(pw.current = props.pag_welcome)
            set_dados(layout.current = props.layout)


            console.log('-->>>>', props.layout)

            setLoading(false)
        }

    }, [props]);

    return (isloading ?
		null
    :
        layout.current === 'home-section-01' ?
            <HomeSection01 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} />
        :
            <HomeSection01 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} />
    )
}
